module.exports = __webpack_public_path__ + "media/images/PrepWorks-feature-img-937ea5ee4e5d1346365e4a558b33f332.jpg";